import {useCallback, useState} from "react";

export type InitializeFetch = () => Promise<void>;
export type CompleteFetch<T> = (result: T) => void;

export const useApiState = function<T>(initialValue: T | undefined): [boolean,T | undefined,InitializeFetch, CompleteFetch<T>] {
    const [state, setState] = useState<{ loading: boolean, value: T | undefined}>({
        loading: false,
        value: undefined
    });

    const setValueState: CompleteFetch<T> = useCallback((result: T): void => {
        setState({
            ...state,
            loading: false,
            value: result
        });
    }, [state]);

    const initializeFetch: InitializeFetch = useCallback((): Promise<void> => {
        setState({
            ...state,
            loading: true
        });
        return Promise.resolve();
    }, [state]);

    return [
        state?.loading,
        state?.value,
        initializeFetch,
        setValueState
    ];
}